export class InvalidDomainSecretError extends Error {
    constructor() {
        super('The provided domain secret is not valid.');
    }
}
export * from './params';
